import { useState } from "react";
import { Sparkles, Send, ArrowRight, MessageCircle } from "lucide-react";
import { openScottie } from "@/lib/events";
import { useSite } from "@/context/SiteContent";

const STARTERS = [
  "What are the 5Ps?",
  "What's inside the eBook?",
  "I just started my first job. Where should I begin?",
  "How should I think about my first paycheck?",
  "How does a 5Ps Conversation with Scott work?",
  "I feel stuck in my career. What now?",
];

export const Assistant = () => {
  const { bookingCta } = useSite();
  const [q, setQ] = useState("");
  const ask = (text) => { const t = (text ?? q).trim(); if (!t) return; setQ(""); openScottie(t); };

  return (
    <section className="assistant-section" data-rail="Ask Scottie" id="ask" data-testid="assistant-section">
      <div className="container assistant-grid">
        <div className="reveal">
          <div className="eyebrow">Ask Scottie, your Campus2Corp guide</div>
          <h2 style={{ color: "white", marginTop: 10 }}>Got a question? Ask Scottie answers in seconds.</h2>
          <p className="lead">Scottie is a mentor-style assistant built on the 5Ps and the eBook. Ask what the 5Ps are, what is inside, how a 5Ps Conversation works, or what to do with your first paycheck. When a question deserves a real conversation, Scottie points you to Scott.</p>
          <ul className="showcase-points">
            <li>Explains the 5Ps and what is inside the eBook</li>
            <li>Helps if a payment or download did not go to plan</li>
            <li>Suggests a 5Ps Conversation when a personal chat would help more</li>
          </ul>
          <div className="showcase-actions">
            <button type="button" className="btn btn-gold" onClick={() => openScottie()} data-testid="assistant-open-btn"><MessageCircle size={16} /> Open Ask Scottie</button>
            <a className="btn btn-outline" href="#booking" data-testid="assistant-booking-btn">{bookingCta}</a>
          </div>
        </div>
        <div className="chat showcase reveal" data-testid="assistant-chat">
          <div className="chat-head">
            <strong className="showcase-title"><Sparkles size={16} /> Ask Scottie</strong>
            <span className="showcase-live"><i /> LIVE AI ASSISTANT</span>
          </div>
          <div className="chat-body showcase-body">
            <div className="bubble bot">Hi, I'm Scottie. Ask me anything about the 5Ps, the eBook or the move from campus to corporate. Tap a question to start.</div>
            <div className="showcase-starters">
              {STARTERS.map((s, i) => (
                <button type="button" key={s} onClick={() => ask(s)} data-testid={`assistant-starter-${i}`}>{s}<ArrowRight size={13} /></button>
              ))}
            </div>
          </div>
          <form className="showcase-input" onSubmit={(e) => { e.preventDefault(); ask(); }} data-testid="assistant-form">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Or type your own question..." aria-label="Ask Scottie a question" data-testid="assistant-input" />
            <button type="submit" className="scottie-send" disabled={!q.trim()} aria-label="Ask" data-testid="assistant-send"><Send size={16} /></button>
          </form>
        </div>
      </div>
    </section>
  );
};
